import { clsx } from "clsx";
import classes from "./progress-dots.module.css";

type ProgressDotsProps = {
	readonly total: number;
	readonly currentIndex: number;
};

function ProgressDots({ currentIndex, total }: ProgressDotsProps) {
	return (
		<div className={classes["progress"]}>
			{Array.from({ length: total }, (_, i) => (
				<div
					key={i}
					className={clsx(
						classes["progress-step"],
						i === currentIndex && classes["progress-step-active"],
					)}
				/>
			))}
		</div>
	);
}

export default ProgressDots;
